import React from 'react';
import NotificationItem from './NotificationItem';

const NotificationList = ({ notifications, onMarkAsRead, onDelete }) => {
    if (!notifications || notifications.length === 0) {
        return <p className="text-center text-muted">No tienes notificaciones.</p>;
    }

    return (
        <div className="list-group gap-3">
            {notifications.map(notification => (
                <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onMarkAsRead={onMarkAsRead}
                    onDelete={onDelete}
                />
            ))}
        </div>
    );
};

export default NotificationList;